import '.cx{border-radius:24px;}.ssr-plugin'
import '.e9{padding:0px;}.ssr-plugin'
import '.ai{position:relative;}.ssr-plugin'
import '.bm{margin-bottom:48px;}.ssr-plugin'
import '.e{display:flex;}.ssr-plugin'
import '.f{flex-direction:column;}.ssr-plugin'
import '.bl{margin-bottom:16px;}.ssr-plugin'
import '.dj{cursor:pointer;}.ssr-plugin'
import '.f0{transition:all .2s ease-out;}.ssr-plugin'
import '.b1{box-sizing:border-box;}.ssr-plugin'
import '.v{border-radius:16px;}.ssr-plugin'
import '.c2{overflow:hidden;}.ssr-plugin'
import '.m{width:100%;}.ssr-plugin'
import '.ba{object-fit:cover;}.ssr-plugin'
import '.de{display:block;}.ssr-plugin'
import '.fu{user-select:none;}.ssr-plugin'
import '.fv{-webkit-user-select:none;}.ssr-plugin'
import '.d6{aspect-ratio:1/1;}.ssr-plugin'
import '.fw{-moz-user-select:none;}.ssr-plugin'
import '.bo{text-align:left;}.ssr-plugin'
import '.ge{line-height:125%;}.ssr-plugin'
import '.gf{align-items:flex-start;}.ssr-plugin'
import '.gg{gap:8px;}.ssr-plugin'
import '.gh{margin-top:2px;}.ssr-plugin'
import '.gi{margin-top:auto;}.ssr-plugin'
import '.do{padding-top:20px;}.ssr-plugin'
import { styled, Style } from 'inlines'
import { Icon } from '../assets/icons/index.js'
import { VoteButton } from './VoteButton.js'
import { colors } from '../utils/colors.js'
import {
  useVotingRegion,
  useVotingRegionName,
} from '../hooks/useVotingRegion.js'
import { Flag } from './Flag.js'
import { parseContestantImageSrc } from '../utils/parseImageSrc.js'

type CardProps = {
  img?: string
  ddi?: number | string
  name?: string
  song?: string
  votingRegion: string
  votes: Record<string, number>
  setVotes?: (selected: Record<string, number>) => void
  setModal: (x?: any) => any
  setModalIndex?: () => any
  maxed?: boolean
  style?: Style
}

export const Card = ({
  img,
  ddi,
  name,
  song,
  votingRegion,
  setModal,
  setModalIndex,
  votes,
  setVotes,
  maxed,
  style,
}: CardProps) => {
  const votingRegionName = useVotingRegionName(votingRegion as string)
  const [{ voteType }] = useVotingRegion()
  const isOnlineVoting = voteType === 'online'

  return (
    <styled.div className="cx e9 ai bm e f"
      id="voting-page-contestant-card-content"
      style={{
        backdropFilter:
          votes?.[votingRegion] && isOnlineVoting ? 'blur(4px)' : 'blur(0px)',
        WebkitBackdropFilter:
          votes?.[votingRegion] && isOnlineVoting ? 'blur(4px)' : 'blur(0px)',
        '& > *': {
          position: 'relative',
        },
        '& h2': {
          fontFamily: 'Neulis-Regular',
          fontWeight: '600',
          letterSpacing: '-0.02em',
          fontSize: 16,
          marginBlockStart: 0,
          marginBlockEnd: 8,
          textAlign: 'left',
        },
        '& p': {
          fontSize: 14,
          display: 'flex',
          alignItems: 'center',
          gap: 8,
        },
        '&::before': {
          content: '" "',
          scale: votes?.[votingRegion] ? 1 : 0.96,
          backgroundColor:
            votes?.[votingRegion] && isOnlineVoting
              ? colors.primary
              : 'transparent',
          position: 'absolute',
          inset: -8,
          opacity: 0.3,
          borderRadius: 24,
          transition: 'all .2s ease-out',
        },
        ...style,
      }}
    >
      <styled.div className="ai bl dj f0 b1 v c2"
        style={{
          '&:hover': {
            scale: 0.985,
          },
          '&:hover::before': {
            content: '""',
            position: 'absolute',
            inset: 0,
            backgroundColor: `${colors.border}`,
            zIndex: 1,
            pointerEvents: 'none',
            borderRadius: 16,
          },
          border: `1px solid ${colors.border}`,
        }}
        id="voting-page-contestant-card-action-open-contestant-modal"
        onClick={() => {
          setModalIndex?.()
          setModal(true)
        }}
      >
        <img className="m ba de fu fv d6 fw v"
          src={parseContestantImageSrc(img as string, 324)}
          alt={name}
          loading="lazy"
          decoding="async"
          draggable={false}
          style={{
            backgroundColor: colors.secondary,
          }}
        />
      </styled.div>
      <h2 className="bo ge">
        {ddi} · {name}
      </h2>
      <div className="e gf gg"
      >
        <Icon type="noteIcon" width={18} />
        <p className="bo gh">
          {song}
        </p>
      </div>
      <div className="e gf gg"
      >
        <Flag code={votingRegion} width={18} />
        <p className="bo gh">
          {votingRegionName}
        </p>
      </div>
      <div className="gi do">
        <VoteButton
          id="voting-page-contestant-card-action-vote-button"
          votingRegion={votingRegion}
          votes={votes}
          setVotes={setVotes}
          maxed={maxed}
        />
      </div>
    </styled.div>
  )
}
